export function notNullOrUndefined<TValue>(
  value: TValue | null | undefined
): value is TValue {
  return value !== null && value !== undefined;
}

/**
 * Converts undefined, null, or empty string values to null.
 * @param value The value to check.
 * @returns The original value if it is not undefined, null, or empty string; otherwise, null.
 */
export function nullIfUndefinedOrEmpty<TValue>(
  value: TValue | undefined | null
): TValue | null {
  if (value === undefined || value === null || value === "") {
    return null;
  }
  return value;
}
